import { Box, Typography } from '@mui/material'
import React from 'react'
import { i18n } from '../../domain/index'

/** Shown in place of a campaigns table/list when a section (current / future) has nothing to list. */
export function EmptyCampaigns() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 180 }}>
      <Typography sx={{ textAlign: 'center', color: 'text.secondary', fontSize: 18 }}>
        {i18n.t('campaigns.noCampaigns')}
      </Typography>
    </Box>
  )
}
